import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';

import { download } from 'Lib/exportHelper';
import Worker from 'Lib/worker/PrimusWorker';
import AdminStore from 'Reducers/store/adminStore';
import { getWalletsForFirm } from 'Selectors/accounts';
import { getAccountWithdrawalRelationshipsByFirmId } from 'Selectors/accountsWithdrawalRelationships';
import { getFirmByFirmId } from 'Selectors/firms';

export const exportWithdrawalFirmData = async (firmId: string): Promise<void> => {
    const store = AdminStore.getState();
    const accounts = getWalletsForFirm(store, firmId)
        .reduce((acc, item) => {
            acc[item.AccountId] = item;

            return acc;
        }, {});

    const firm = getFirmByFirmId(store, firmId);
    let withdrawalsFirmData: Array<AccountWithdrawalDataRecord> = [];
    const response: {
        data: {
            Status: number;
            withdrawals: Array<AccountWithdrawalDataRecord>;
        };
    } = await Worker.getInstance()
        .getFirmWithdrawalInstructions(firmId);
    withdrawalsFirmData = response.data.withdrawals;
    const accountsWithdrawalRelationships = getAccountWithdrawalRelationshipsByFirmId(store, firmId);

    let exportDataString = [
        'Withdrawal ID',
        'Status',
        'Firm Name',
        'Associated Account Name',
        'Withdrawal Description',
        'Withdrawal Type',
        'Beneficiary Name',
        'Beneficiary Account Number',
        'Beneficiary Street Address',
        'Beneficiary City',
        'Beneficiary State/Province',
        'Beneficiary Postal Code',
        'Beneficiary Country Code',
        'Beneficiary Bank Name',
        'Beneficiary Bank Account Type',
        'Beneficiary Bank ABA',
        'Beneficiary Bank SWIFT BIC',
        'Beneficiary Bank Street Address',
        'Beneficiary Bank City',
        'Beneficiary Bank State/Province',
        'Beneficiary Bank Postal Code',
        'Beneficiary Bank Country Code',
        'Intermediary Bank Name',
        'Intermediary Bank ABA',
        'Intermediary Bank SWIFT BIC',
        'Intermediary Bank Street Address',
        'Intermediary Bank City',
        'Intermediary Bank State/Province',
        'Intermediary Bank Postal Code',
        'Intermediary Bank Country Code',
        'Beneficiary Information 1',
        'Beneficiary Information 2',
        'Beneficiary Information 3',
        'Beneficiary Information 4',
        'Bank to Bank Information 1',
        'Bank to Bank Information 2',
        'Bank to Bank Information 3',
        'Bank to Bank Information 4\n'
    ].join(',');

    withdrawalsFirmData.forEach((withdrawalFirmData) => {
        const associatedAccounts = accountsWithdrawalRelationships
            .filter((item) => item.AccountWithdrawalDataId === withdrawalFirmData.AccountWithdrawalDataId);

        if (!associatedAccounts.length) {
            const exportRowData = [
                `="${withdrawalFirmData.AccountWithdrawalDataId}"`,
                `${withdrawalFirmData.IsDeleted ? 'Deleted' : 'Active'}`,
                `"${firm.Name}"`,
                '""',
                `"${withdrawalFirmData.Description}"`,
                `"${withdrawalFirmData.WithdrawalType}"`,
                `"${withdrawalFirmData.BeneName ?? ''}"`,
                `="${withdrawalFirmData.BeneBankAcct ?? ''}"`,
                `"${withdrawalFirmData.BeneStreetAddress ?? ''}"`,
                `"${withdrawalFirmData.BeneCity ?? ''}"`,
                `"${withdrawalFirmData.BeneStateProv ?? ''}"`,
                `"${withdrawalFirmData.BenePostalCode ?? ''}"`,
                `"${withdrawalFirmData.BeneCountry ?? ''}"`,
                `"${withdrawalFirmData.BeneBankName ?? ''}"`,
                `"${withdrawalFirmData.BeneBankAccountType ?? ''}"`,
                `="${withdrawalFirmData.BeneBankRoutNum ?? ''}"`,
                `"${withdrawalFirmData.BeneBankBic ?? ''}"`,
                `"${withdrawalFirmData.BeneBankStreetAddress}"`,
                `"${withdrawalFirmData.BeneBankCity ?? ''}"`,
                `"${withdrawalFirmData.BeneBankStateProv ?? ''}"`,
                `"${withdrawalFirmData.BeneBankPostalCode ?? ''}"`,
                `"${withdrawalFirmData.BeneBankCountry ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankName ?? ''}"`,
                `="${withdrawalFirmData.IntermediaryBankRoutNum ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankBic ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankStreetAddress ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankCity ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankStateProv ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankPostalCode ?? ''}"`,
                `"${withdrawalFirmData.IntermediaryBankCountry ?? ''}"`,
                `"${withdrawalFirmData.BeneInfo1 ?? ''}"`,
                `"${withdrawalFirmData.BeneInfo2 ?? ''}"`,
                `"${withdrawalFirmData.BeneInfo3 ?? ''}"`,
                `"${withdrawalFirmData.BeneInfo4 ?? ''}"`,
                `"${withdrawalFirmData.BankToBankInfo1 ?? ''}"`,
                `"${withdrawalFirmData.BankToBankInfo2 ?? ''}"`,
                `"${withdrawalFirmData.BankToBankInfo3 ?? ''}"`,
                `"${withdrawalFirmData.BankToBankInfo4 ?? ''}"\n`
            ].join(',');

            exportDataString += exportRowData;
        } else {
            associatedAccounts.forEach((item) => {
                const exportRowData = [
                    `="${withdrawalFirmData.AccountWithdrawalDataId}"`,
                    `${withdrawalFirmData.IsDeleted ? 'Deleted' : 'Active'}`,
                    `"${firm.Name}"`,
                    `"${accounts[item.AccountId]?.AccountName ?? ''}"`,
                    `"${withdrawalFirmData.Description}"`,
                    `"${withdrawalFirmData.WithdrawalType}"`,
                    `"${withdrawalFirmData.BeneName ?? ''}"`,
                    `="${withdrawalFirmData.BeneBankAcct ?? ''}"`,
                    `"${withdrawalFirmData.BeneStreetAddress ?? ''}"`,
                    `"${withdrawalFirmData.BeneCity ?? ''}"`,
                    `"${withdrawalFirmData.BeneStateProv ?? ''}"`,
                    `"${withdrawalFirmData.BenePostalCode ?? ''}"`,
                    `"${withdrawalFirmData.BeneCountry ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankName ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankAccountType ?? ''}"`,
                    `="${withdrawalFirmData.BeneBankRoutNum ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankBic ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankStreetAddress ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankCity ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankStateProv ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankPostalCode ?? ''}"`,
                    `"${withdrawalFirmData.BeneBankCountry ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankName ?? ''}"`,
                    `="${withdrawalFirmData.IntermediaryBankRoutNum ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankBic ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankStreetAddress ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankCity ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankStateProv ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankPostalCode ?? ''}"`,
                    `"${withdrawalFirmData.IntermediaryBankCountry ?? ''}"`,
                    `"${withdrawalFirmData.BeneInfo1 ?? ''}"`,
                    `"${withdrawalFirmData.BeneInfo2 ?? ''}"`,
                    `"${withdrawalFirmData.BeneInfo3 ?? ''}"`,
                    `"${withdrawalFirmData.BeneInfo4 ?? ''}"`,
                    `"${withdrawalFirmData.BankToBankInfo1 ?? ''}"`,
                    `"${withdrawalFirmData.BankToBankInfo2 ?? ''}"`,
                    `"${withdrawalFirmData.BankToBankInfo3 ?? ''}"`,
                    `"${withdrawalFirmData.BankToBankInfo4 ?? ''}"\n`
                ].join(',');

                exportDataString += exportRowData;
            });
        }
    });

    download(`Lynq_Platform_${firm.Name}_Withdrawal_Information.csv`, exportDataString);
};